var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobustIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.036,
    height: 102.435,
    viewBox: "0 0 146.036 102.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(1238.594 1130.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218",
    transform: "translate(-1238.594 -1130.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    d: "M-1034.077-996.565h-140.394a2.808 2.808 0 0 1-2.821-2.787v-96.86a2.808 2.808 0 0 1 2.821-2.787h140.394a2.808 2.808 0 0 1 2.821 2.787v96.86a2.808 2.808 0 0 1-2.821 2.787zm-140.394-101.042a1.4 1.4 0 0 0-1.411 1.394v96.86a1.4 1.4 0 0 0 1.411 1.394h140.394a1.4 1.4 0 0 0 1.411-1.394v-96.86a1.4 1.4 0 0 0-1.411-1.394z",
    fill: "#017cee",
    "data-name": "Path 1057",
    transform: "translate(1177.292 1099)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(1.017 12.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_455",
    d: "M0 0h144.625v1.41H0z",
    fill: "#017cee",
    "data-name": "Rectangle 455"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208",
    transform: "translate(6.334 5.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 116"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(10.721)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207",
    transform: "translate(5.361)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    cx: 1.675,
    cy: 1.675,
    r: 1.675,
    fill: "#017cee",
    "data-name": "Ellipse 118"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217",
    transform: "translate(10.615 22.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211",
    transform: "translate(42.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    d: "M-988.192-1030.647v9.14h-35.876v-9.14h35.876m.144-1.411h-36.164a1.266 1.266 0 0 0-1.266 1.266v9.428a1.266 1.266 0 0 0 1.266 1.266h36.164a1.266 1.266 0 0 0 1.266-1.266v-9.428a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1058",
    transform: "translate(1025.478 1032.058)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212",
    transform: "translate(0 28.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    d: "M-1109.9-950.837v35.876h-35.876v-35.876h35.876m.144-1.41h-36.165a1.266 1.266 0 0 0-1.266 1.266v36.164a1.266 1.266 0 0 0 1.266 1.266h36.165a1.266 1.266 0 0 0 1.266-1.266v-36.164a1.267 1.267 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1059",
    transform: "translate(1147.189 952.247)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213",
    transform: "translate(42.918 28.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    d: "M-988.192-950.837v35.876h-35.876v-35.876h35.876m.144-1.41h-36.164a1.266 1.266 0 0 0-1.266 1.266v36.164a1.266 1.266 0 0 0 1.266 1.266h36.164a1.266 1.266 0 0 0 1.266-1.266v-36.164a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1060",
    transform: "translate(1025.478 952.247)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214",
    transform: "translate(85.836 28.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    d: "M-866.48-950.837v35.876h-35.876v-35.876h35.876m.144-1.41H-902.5a1.266 1.266 0 0 0-1.266 1.266v36.164a1.266 1.266 0 0 0 1.266 1.266h36.164a1.266 1.266 0 0 0 1.266-1.266v-36.164a1.266 1.266 0 0 0-1.266-1.266z",
    fill: "#017cee",
    "data-name": "Path 1061",
    transform: "translate(903.766 952.247)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215",
    transform: "translate(61.561 11.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_456",
    d: "M0 0h1.41v17.894H0z",
    fill: "#017cee",
    "data-name": "Rectangle 456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(18.643 19.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    d: "M-1007.073-967.692h-1.41v-8.089h-84.426v8.089h-1.411v-8.795a.705.705 0 0 1 .705-.705h85.837a.705.705 0 0 1 .705.705z",
    fill: "#017cee",
    "data-name": "Path 1062",
    transform: "translate(1094.32 977.192)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobustIntegrations);
export default __webpack_public_path__ + "static/media/RobustIntegrations.36b15441117727a9e2f40a4d65c50d70.svg";
export { ForwardRef as ReactComponent };